define('models/Address',['core/can'], function(can) {
	
	return can.Map.extend({
		
		define: {
			Line1: {},
			Line2: {},
			City: {},
			State: {},
			ZipCode: {},
			ZipCodeExt: {}
		},
		
		_Format: can.compute(function() {
			
			var pieces = [];
			
			var line1 = this.attr('Line1');
			if (line1 && line1.trim() !== '') {
				pieces.push(line1);
			}
			
			var line2 = this.attr('Line2')
			if (line2 && line2.trim() !== '') {
				pieces.push(line2);
			}
			
			var city = this.attr('City'),
				state = this.attr('State'),
				zip = this.attr('ZipCode'),
				ext = this.attr('ZipCodeExt');
			if (city && state && zip) {
				pieces.push( city + ', ' + state + ' ' + zip + '-' + ext);
			}
			
			return pieces.join('<br>');
		})
	});

});
